import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// This array holds your images paired with real land surveying content
const slidesData = [
  {
    img: "/images/image1.webp",
    title: "Precision Boundary Subdivision",
    desc: "Whether you’re buying, building, or developing, we provide the boundary cutting and splitting solutions you need to move forward with confidence. Protect your property line with legal accuracy.",
    primaryLink: "/Landing",
    primaryText: "Explore Services",
  },
  {
    img: "/images/image2.jpg",
    title: "Topographic Mapping & Terrain Data",
    desc: "Get clear, reliable 3D contour maps and elevation measurements before you build. Our mission is to give you accurate information so you can make the best decisions for your construction projects.",
    primaryLink: "/regist",
    primaryText: "Book a Survey",
  },
  {
    img: "/images/image3.png",
    title: "Official Cadastral Certification",
    desc: "We measure and draw precise land maps compliant with state land registry systems. Move your files seamlessly through the validation process and secure your official land title deeds.",
    primaryLink: "/login",
    primaryText: "Get Started",
  }
];

export default function ImageCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === slidesData.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000); // Your exact 4-second interval

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative w-full h-[550px] sm:h-[500px] overflow-hidden">
      {/* Sliding images track */}
      <div
        className="flex h-full transition-transform duration-1000 ease-in-out"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {slidesData.map((slide, index) => (
          <div
            key={index}
            className="relative flex-shrink-0 w-full h-full group"
          >
            <img
              src={slide.img}
              alt={`carousel-${index}`}
              className="object-cover w-full h-full"
            />
            {/* Your exact gradient overlay */}
            <div className="absolute inset-0 transition-opacity duration-700 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-80 group-hover:opacity-90"></div>
          </div>
        ))}
      </div>

      {/* Caption overlay - Made fully responsive while keeping your original spacing */}
      <div className="absolute z-10 max-w-2xl text-white bottom-8 left-6 right-6 sm:bottom-12 sm:left-12 sm:right-auto">
        
        {/* Added a dynamic Title based on the active image */}
        <h2 className="mb-2 text-2xl font-extrabold tracking-tight text-yellow-500 sm:text-3xl drop-shadow-lg">
          {slidesData[currentIndex].title}
        </h2>

        <p className="mb-6 text-sm font-semibold leading-relaxed sm:mb-8 sm:text-xl drop-shadow-lg">
          {slidesData[currentIndex].desc}
        </p>
        
        {/* Button Wrapper: Stacked on mobile, side-by-side on desktop */}
        <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:gap-6">
          
          {/* Your exact Primary Button design */}
          <Link 
            to='/explore'
            className="w-full sm:w-[220px] h-[55px] rounded-full text-white font-bold tracking-wide flex items-center justify-center gap-2
              bg-gradient-to-br from-pink-600 via-rose-500 to-red-600 
              shadow-[0_10px_20px_-5px_rgba(225,29,72,0.4)] 
              border-t border-white/20 
              hover:from-pink-500 hover:to-red-500 transition-all duration-300 hover:scale-95 hover:-translate-y-2"
          >
           Explore More<span>&#8594;</span>
          </Link>

          {/* Your exact Secondary Button design */}
          <Link 
            to="/login"
            className="w-full sm:w-[220px] h-[55px] rounded-full text-white font-bold tracking-wide flex items-center justify-center gap-2
              bg-gradient-to-br from-slate-800 via-slate-900 to-black 
              shadow-[0_10px_20px_-5px_rgba(30,41,59,0.4)] 
              border-t border-white/10 
              hover:from-slate-700 hover:to-slate-900 transition-all duration-300 hover:scale-95 hover:translate-x-2"
          >
            Get Started <span>&#8594;</span>
          </Link>
        </div>
      </div>

      {/* Your exact Navigation dots layout */}
      <div className="absolute z-20 flex justify-center w-full gap-3 bottom-4">
        {slidesData.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-3 h-3 rounded-full transition-all duration-500 ${
              currentIndex === index ? "bg-white scale-125" : "bg-gray-400"
            }`}
          ></button>
        ))}
      </div>
    </div>
  );
}